import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { collection, getDocs } from "firebase/firestore";
import BgImage from "../assets/login_image2.jpg";
import EmployeeImage from "../assets/login_image1.jpg";

const EmployeeLogin = () => {
    const [role, setRole] = useState("Employee");
    const [userId, setUserId] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        try {
            const predefinedEmail = "jskm@technologies.com";
            const predefinedPassword = "jskmtechnologies.in";

            await signInWithEmailAndPassword(auth, predefinedEmail, predefinedPassword);
            console.log("✅ Predefined Firebase login successful");

            const collectionName = role === "Admin" ? "Admin_IDS" : "Employee_IDS";
            const userRef = collection(db, collectionName);
            const snapshot = await getDocs(userRef);

            let foundUser = null;
            snapshot.forEach((doc) => {
                const data = doc.data();
                if (
                    (data.JSKMID?.trim() === userId.trim() ||
                        data.AdminID?.trim() === userId.trim()) &&
                    data.Password?.trim() === password.trim()
                ) {
                    foundUser = { id: doc.id, ...data };
                }
            });

            if (foundUser) {
                Object.entries(foundUser).forEach(([key, value]) =>
                    localStorage.setItem(key, value)
                );
                localStorage.setItem("role", role);

                console.log(`✅ ${role} verified and stored in localStorage`);

                // redirect
                if (role === "Admin") {
                    navigate("/admin-dashboard");
                } else {
                    navigate("/employee-dashboard");
                }
                window.location.reload();
            } else {
                setError(`Invalid ${role} ID or Password!`);
            }
        } catch (err) {
            console.error("❌ Login error:", err);
            setError("Login failed! Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                {/* Left Image */}
                <div style={styles.imageContainer}>
                    <img src={EmployeeImage} alt="Login Visual" style={styles.image} />
                </div>

                {/* Right Side */}
                <div style={styles.formContainer}>
                    <h2 style={styles.title}>{role} Login</h2>

                    {/* 🔹 Role Selection Dropdown */}
                    <div style={styles.dropdownGroup}>
                        <label style={styles.label}>Select Role</label>
                        <select
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                            style={styles.dropdown}
                        >
                            <option value="Employee">Employee</option>
                            <option value="Admin">Admin</option>
                        </select>
                    </div>

                    <form onSubmit={handleLogin} style={styles.form}>
                        <div style={styles.inputGroup}>
                            <label style={styles.label}>{role} ID</label>
                            <input
                                type="text"
                                value={userId}
                                onChange={(e) => setUserId(e.target.value)}
                                placeholder={`Enter your ${role} ID`}
                                style={styles.input}
                                required
                            />
                        </div>

                        <div style={styles.inputGroup}>
                            <label style={styles.label}>Password</label>
                            <div style={styles.passwordWrapper}>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder={`Enter your ${role} password`}
                                    style={{ ...styles.input, paddingRight: "44px" }} // space for toggle
                                    required
                                />

                                <button
                                    type="button"
                                    onClick={() => setShowPassword((s) => !s)}
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                    style={styles.toggleButton}
                                >
                                    {showPassword ? "🙈" : "👁️"}
                                </button>
                            </div>
                        </div>

                        {error && <p style={styles.errorMessage}>{error}</p>}

                        <button type="submit" style={styles.button} disabled={loading}>
                            {loading ? "Logging in..." : "Login"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

const styles = {
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundImage: `url(${BgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        fontFamily: "Arial, sans-serif",
    },
    card: {
        display: "flex",
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        backdropFilter: "blur(8px)",
        borderRadius: "16px",
        overflow: "hidden",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
        width: "850px",
        maxWidth: "90%",
    },
    imageContainer: {
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "rgba(255, 255, 255, 0.1)",
    },
    image: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },
    formContainer: {
        flex: 0.9,
        padding: "50px 40px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    title: {
        fontSize: "28px",
        fontWeight: "600",
        color: "#666464ff",
        textAlign: "center",
        marginBottom: "30px",
    },
    dropdownGroup: {
        display: "flex",
        flexDirection: "column",
        marginBottom: "20px",
    },
    dropdown: {
        padding: "12px 15px",
        borderRadius: "8px",
        border: "1px solid #e87115",
        outline: "none",
        fontSize: "15px",
        fontWeight: "500",
        color: "#333",
        backgroundColor: "#fff",
        cursor: "pointer",
        appearance: "none",
        WebkitAppearance: "none",
        MozAppearance: "none",
        backgroundImage:
            "linear-gradient(45deg, transparent 50%, #e87115 50%), linear-gradient(135deg, #e87115 50%, transparent 50%)", // custom arrow
        backgroundPosition: "calc(100% - 15px) calc(1em + 2px), calc(100% - 10px) calc(1em + 2px)",
        backgroundSize: "5px 5px, 5px 5px",
        backgroundRepeat: "no-repeat",
        transition: "border 0.3s, box-shadow 0.3s",
    },
    form: {
        display: "flex",
        flexDirection: "column",
        gap: "20px",
    },
    inputGroup: {
        display: "flex",
        flexDirection: "column",
    },
    label: {
        color: "#5c5b5bff",
        marginBottom: "8px",
        fontSize: "14px",
    },
    input: {
        padding: "12px 15px",
        borderRadius: "8px",
        border: "none",
        outline: "none",
        fontSize: "15px",
        backgroundColor: "rgba(255, 255, 255, 0.85)",
    },
    button: {
        marginTop: "10px",
        padding: "12px",
        backgroundColor: "#e87115",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        fontSize: "16px",
        cursor: "pointer",
        fontWeight: "bold",
        transition: "background 0.3s",
    },
    errorMessage: {
        color: "red",
        textAlign: "center",
        margin: "-15px",
        fontSize: "14px",
        fontWeight: "bold",
    },
    passwordWrapper: {
        position: "relative",
        display: "flex",
        alignItems: "center",
    },
    toggleButton: {
        position: "absolute",
        right: "8px",
        top: "50%",
        transform: "translateY(-50%)",
        background: "transparent",
        border: "none",
        cursor: "pointer",
        padding: "6px",
        borderRadius: "6px",
        fontSize: "18px",
        lineHeight: 1,
    },
};

export default EmployeeLogin;